import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import icQuestion from 'assets/svgs/ic-question.svg';
import ToolTip from 'components/tooltip';

const Help = ({ text, className }) => (
  <ToolTip text={text} className={className}>
    <ReactSVG src={icQuestion} />
  </ToolTip>
);

Help.propTypes = {
  text: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Help.defaultProps = {
  className: null,
};

export default Help;
